import React from "react"

import {
    TabContext,
    TabPanel,
} from "@mui/lab"
import { Box } from "@mui/material"

import { t } from "@lingui/macro"

import {
    SbTab,
    SbTabList,
} from "components/commons"
import { BrandPriority } from "models"

import { ResearchDetailCard } from "../research-detail-card"

interface ResearchColumnTwoProps {
    researchData: BrandPriority
}
interface ResearchColumnTwoState {
}
export class ResearchColumnTwo extends React.Component<ResearchColumnTwoProps, ResearchColumnTwoState> {
    render() {
        return (
            <TabContext value={"1"}>
                <Box sx={{ borderBottom: 0 }}>
                    <SbTabList variant="fullWidth">
                        <SbTab
                            disableRipple
                            disableTouchRipple
                            label={t({ id: "research.my-opening-detail", message: "Dettagli apertura", })}
                            value="1" />
                    </SbTabList>
                </Box>
                <TabPanel value="1" sx={{ px: 0, }}>
                    <ResearchDetailCard data={this.props.researchData} />
                </TabPanel>
            </TabContext>
        )
    }
}
